import React from "react";

const steps = [
  {
    n: "I",
    title: "Décrivez votre voyage",
    desc: "Remplissez un formulaire en 5 minutes : destination, dates, envies profondes et budget total.",
  },
  {
    n: "II",
    title: "Votre dossier prend forme",
    desc: "Je compose votre itinéraire jour par jour — riche, précis et enthousiaste, comme si je vous accompagnais moi-même.",
  },
  {
    n: "III",
    title: "Je valide et peaufine",
    desc: "Je relis chaque détail, j'ajuste si nécessaire, et donne mon aval avant que l'itinéraire vous soit livré.",
  },
  {
    n: "IV",
    title: "Votre voyage, débloqué",
    desc: "Choisissez l'offre qui vous correspond — et partez l'esprit léger. Je m'occupe de tout.",
  },
];

export default function LandingSteps() {
  return (
    <section className="py-20 max-w-7xl mx-auto px-5 sm:px-8">
      <div className="text-center mb-14">
        <p className="section-label mb-3">Le processus</p>
        <h2
          className="text-4xl sm:text-5xl"
          style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 600, color: "#2B2623" }}
        >
          Quatre étapes vers l'aventure
        </h2>
      </div>
      <div className="grid md:grid-cols-4 gap-6">
        {steps.map((s, i) => (
          <div
            key={i}
            className="relative animate-fade-in-up"
            style={{ animationDelay: `${i * 120}ms` }}
            data-testid={`step-${i}`}
          >
            {i < steps.length - 1 && (
              <div
                className="hidden md:block absolute top-6 h-px border-t border-dashed border-[#DCD4C6] z-0"
                style={{ width: "calc(100% - 3rem)", left: "3rem" }}
              />
            )}
            <div className="text-center relative z-10">
              <div
                className="w-12 h-12 border-2 border-[#C17F59] flex items-center justify-center mx-auto mb-5"
                style={{ borderRadius: "50%", fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 600, fontSize: "1.1rem", color: "#C17F59" }}
              >
                {s.n}
              </div>
              <h3 className="mb-2 text-lg" style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 600, color: "#2B2623" }}>
                {s.title}
              </h3>
              <p className="text-sm text-[#5C554E] leading-relaxed" style={{ fontFamily: "'Lora', Georgia, serif" }}>
                {s.desc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
